module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "color": "green",
      "dark": ""
    }
  }, [_vm._v("BETA")]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "warning",
      "dense": "",
      "prominent": "",
      "outlined": "",
      "text": ""
    }
  }, [_vm._v("\n        Funktioniert noch nicht. "), _c('br'), _vm._v("\n        Die Striche werden zwar schon eingetragen. Allerdings wird noch keine Rechnung generiert.\n      ")]), _vm._v(" "), _c('v-card', {
    staticClass: "mt-2 pt-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pt-4",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Bundesbruder",
      "items": _vm.bundesbruderselect
    },
    model: {
      value: (_vm.neueRechnung.bbrID),
      callback: function($$v) {
        _vm.$set(_vm.neueRechnung, "bbrID", $$v)
      },
      expression: "neueRechnung.bbrID"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Rechnungstitel"
    },
    model: {
      value: (_vm.neueRechnung.rechnung_titel),
      callback: function($$v) {
        _vm.$set(_vm.neueRechnung, "rechnung_titel", $$v)
      },
      expression: "neueRechnung.rechnung_titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4",
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c('v-menu', {
    ref: "neueRechnung.datum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "label": "Rechnungsdatum",
            "readonly": ""
          },
          model: {
            value: (_vm.formatDatum),
            callback: function($$v) {
              _vm.formatDatum = $$v
            },
            expression: "formatDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.neueRechnung.datum),
      callback: function($$v) {
        _vm.$set(_vm.neueRechnung, "datum", $$v)
      },
      expression: "neueRechnung.datum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4",
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c('v-menu', {
    ref: "neueRechnung.zahlbar_bis",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "label": "Zahlbar bis",
            "readonly": ""
          },
          model: {
            value: (_vm.formatZahlbar_bis),
            callback: function($$v) {
              _vm.formatZahlbar_bis = $$v
            },
            expression: "formatZahlbar_bis"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu2 = false
      }
    },
    model: {
      value: (_vm.neueRechnung.zahlbar_bis),
      callback: function($$v) {
        _vm.$set(_vm.neueRechnung, "zahlbar_bis", $$v)
      },
      expression: "neueRechnung.zahlbar_bis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "rows": "5",
      "label": "Freitext",
      "hint": "<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>",
      "auto-grow": "",
      "outlined": ""
    },
    model: {
      value: (_vm.neueRechnung.freitext),
      callback: function($$v) {
        _vm.$set(_vm.neueRechnung, "freitext", $$v)
      },
      expression: "neueRechnung.freitext"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "my-4 py-4",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "EKP-Getränke",
      "items": _vm.getrankeselect
    },
    model: {
      value: (_vm.ekp),
      callback: function($$v) {
        _vm.ekp = $$v
      },
      expression: "ekp"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "3",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "name": "",
      "label": "Anzahl Getränke",
      "id": ""
    },
    model: {
      value: (_vm.ekp_anzahl),
      callback: function($$v) {
        _vm.ekp_anzahl = $$v
      },
      expression: "ekp_anzahl"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "3",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "name": "",
      "label": "Pauschal",
      "id": ""
    },
    model: {
      value: (_vm.pauschal),
      callback: function($$v) {
        _vm.pauschal = $$v
      },
      expression: "pauschal"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8",
      "sm": "5",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "name": "",
      "label": "Grund",
      "id": ""
    },
    model: {
      value: (_vm.grund),
      callback: function($$v) {
        _vm.grund = $$v
      },
      expression: "grund"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8",
      "sm": "5",
      "md": "4"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "large": "",
      "dark": ""
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4"
  }), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "calc(100vh - 510px)",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Was")]), _vm._v(" "), _c('th', [_vm._v("Anzahl")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Preis")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.was))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.preis)))]), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          return _vm.deleteStrich(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)])
  }), 0)])], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v("\n          Summe: " + _vm._s(_vm._f("money")(_vm.summe)) + "\n        ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "info",
      "dense": "",
      "prominent": "",
      "outlined": "",
      "text": ""
    }
  }, [_vm._v("\n        Die Rechnung wird als Entwurf gespeichert. Und kann im Menü Rechnungen versendet werden."), _c('br'), _vm._v("\n        Getränke werden direkt in der Schankverlustrechnung berücksichtigt.\n      ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-4 text-right",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": "",
      "x-large": "",
      "block": "",
      "dark": ""
    },
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v("Rechnung speichern")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-445e00a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/bierwartVeranstaltungAbrechnen.vue
// module id = 766
// module chunks = 15